import { getTrackingDispatchers, TrackingEvent } from '@owc/connection-aem-tracking';

const getEventToBePushed = (eventDetail: { category: string; label: string }): TrackingEvent => {
  return {
    event: 'click',
    application: {
      id: 'seamless_generic',
      version: process.env.VUE_APP_VERSION || '',
      parentApplicationId: 'aem',
    },
    eventDetail: {
      action: 'header.region_picker',
      ...eventDetail,
    },
  };
};

export const useTracking = () => {
  let trackingDispatcher: any;

  const trackSetRegion = async () => {
    trackingDispatcher = trackingDispatcher || (await getTrackingDispatchers());
    trackingDispatcher.pushTrackingEvent(getEventToBePushed({ category: 'feature', label: 'continue' }));
  };

  const trackOpenFlyout = async () => {
    trackingDispatcher = trackingDispatcher || (await getTrackingDispatchers());
    trackingDispatcher.pushTrackingEvent(getEventToBePushed({ category: 'impression', label: 'modal' }));
  };

  return {
    trackSetRegion,
    trackOpenFlyout,
  };
};
